
export function
  wrapFilters (expression, filters) {
    return {
      type: 'filter',
      expression,
      by: filters,
  }
}
